import React, { useState } from "react";
import { Flex, InputNumber } from "antd";

const NumberRangeInput = ({ value = null, onChange }) => {
  const [start, setStart] = useState(value?.[0]);
  const [end, setEnd] = useState(value?.[1]);

  const triggerChange = (changedValue) => {
    onChange?.(changedValue);
  };

  const onNumberChange = (newValue, isStart) => {
    let newNumber = parseInt(newValue, 10);
    newNumber = Number.isNaN(newNumber) ? null : newNumber;

    if (isStart) {
      setStart(newNumber);
    } else {
      setEnd(newNumber);
    }
    let newRange = isStart ? [newNumber, end] : [start, newNumber];
    if (newRange[0] === null && newRange[1] === null) {
      newRange = null;
    }

    triggerChange(newRange);
  };

  return (
    <Flex gap="small" align="center">
      <InputNumber
        value={start}
        onChange={(newValue) => onNumberChange(newValue, true)}
        max={end}
        className="flex-1"
      />
      <span>-</span>
      <InputNumber
        value={end}
        onChange={(newValue) => onNumberChange(newValue, false)}
        min={start}
        className="flex-1"
      />
    </Flex>
  );
};

export default NumberRangeInput;
